import React, { useState } from 'react';
import styled from 'styled-components';

interface InfoTooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
}

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipBox = styled.div<{ visible: boolean }>`
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: solid #efefef 1px;
  border-radius: 5px;
  padding: 6px 10px;
  color: black;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  font-size: 0.8em;
  font-weight: 500;
  white-space: nowrap;
  z-index: 9999;
  pointer-events: none;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
`;

function InfoTooltip({ content, children }: InfoTooltipProps): JSX.Element {
  const [visible, setVisible] = useState(false);

  return (
    <Wrapper
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      <TooltipBox visible={visible}>{content}</TooltipBox>
    </Wrapper>
  );
}

export default InfoTooltip;
